<mat-card class="example-card">
  <mat-card-header class="card-header">
    <mat-card-title class="card-titulo">{{'MovimientoPago' | translate}} Masivo</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>

  <mat-card-content style="margin-bottom: 0%;">

    <mat-label class="text-style" *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    <mat-label class="text-style" *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
    <mat-label class="text-style" *ngIf="!isSearching && msgError.length > 0">{{msgError}}</mat-label>

    <!--LISTADO DE PAGOS A IMPORTAR-->
    <mat-expansion-panel [expanded]="true" style="margin-bottom: 1%;">

      <mat-expansion-panel-header>
        <mat-panel-title class="card-subtitulo">
          <mat-icon style="margin-top: -3px;">playlist_add_check</mat-icon> Listado de {{'MovimientoPago' | translate}}s a Cargar
        </mat-panel-title>
        <mat-panel-description>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <mat-tab-group (selectedTabChange)="onTabChange($event)">

        <!--SELECCION DE DEUDAS EXISTENTES A SALDAR-->
        <mat-tab label="Buscador de {{'MovimientoDeuda' | translate}}s Pendientes">

          <!--BUSCADOR DE DEUDAS-->
          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" *ngIf="!pagosSaved" style="margin-top: 10px;">

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">

              <mat-expansion-panel *ngIf="!isMovimientoDeudaSearching">

                <mat-expansion-panel-header style="background-color: #ffd000BB;">
                  <mat-panel-title>
                    <mat-icon style="margin-top: -3px;">search</mat-icon> ¿Queres refinar la búsqueda de las deudas pendientes?
                  </mat-panel-title>
                  <mat-panel-description>
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <form [formGroup]="searchDeudaForm">

                  <div fxLayout="row stretch" fxLayout.xs="column">

                    <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label class="text-style" *ngIf="!isMonedaSearching">Moneda</mat-label>
                        <mat-label class="text-style" *ngIf="isMonedaSearching">Cargando...</mat-label>
                        <mat-select class="text-style" formControlName="MonedaId">
                          <mat-option class="text-style">Todas</mat-option>
                          <mat-option class="text-style" *ngFor="let s of monedaList" [value]="s.Id">{{s.Codigo}} - {{s.Nombre}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%" >
                        <mat-label class="text-style">Fecha Movimiento Desde</mat-label>
                        <input class="text-style" matInput [matDatepicker]="fechaMovimientoDesdePicker" formControlName="FechaMovimientoDesde"  (click)="fechaMovimientoDesdePicker.open()">
                        <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaMovimientoDesdePicker">
                        </mat-datepicker-toggle>
                        <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDeudaDate('FechaMovimientoDesde')">
                          <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #fechaMovimientoDesdePicker></mat-datepicker>
                      </mat-form-field>
                    </div>
                    <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label class="text-style">Fecha Movimiento Hasta</mat-label>
                        <input class="text-style" matInput [matDatepicker]="fechaMovimientoHastaPicker" formControlName="FechaMovimientoHasta"  (click)="fechaMovimientoHastaPicker.open()">
                        <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaMovimientoHastaPicker">
                        </mat-datepicker-toggle>
                        <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDeudaDate('FechaMovimientoHasta')">
                          <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #fechaMovimientoHastaPicker></mat-datepicker>
                      </mat-form-field>
                    </div>

                    <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label>Detalle</mat-label>
                        <input matInput formControlName="Detalle" (keyup.enter)="searchGastosPendientes()">
                        <mat-icon matSuffix>search</mat-icon>
                      </mat-form-field>
                    </div>
                    <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%" >
                        <mat-label class="text-style">Fecha Vencimiento Desde</mat-label>
                        <input class="text-style" matInput [matDatepicker]="fechaVencimientoDesdePicker" formControlName="FechaVencimientoDesde"  (click)="fechaVencimientoDesdePicker.open()">
                        <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaVencimientoDesdePicker">
                        </mat-datepicker-toggle>
                        <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDeudaDate('FechaVencimientoDesde')">
                          <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #fechaVencimientoDesdePicker></mat-datepicker>
                      </mat-form-field>
                    </div>
                    <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label class="text-style">Fecha Vencimiento Hasta</mat-label>
                        <input class="text-style" matInput [matDatepicker]="fechaVencimientoHastaPicker" formControlName="FechaVencimientoHasta"  (click)="fechaVencimientoHastaPicker.open()">
                        <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaVencimientoHastaPicker">
                        </mat-datepicker-toggle>
                        <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDeudaDate('FechaVencimientoHasta')">
                          <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #fechaVencimientoHastaPicker></mat-datepicker>
                      </mat-form-field>
                    </div>

                    <ng-container *ngIf="tenantFeatureFlags?.HabilitarControlPedidos || tenantFeatureFlags?.HabilitarControlContratos">

                      <hr width="100%" style="margin: 5px 0px;">

                      <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarControlPedidos">
                        <mat-form-field appearance="outline" style="width: 100%">
                          <mat-label>Nro. Pedido</mat-label>
                          <input matInput formControlName="PedidoId" type="number" (keyup.enter)="onSearch()">
                          <mat-icon matSuffix>search</mat-icon>
                        </mat-form-field>
                      </div>
                      <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarControlContratos">
                        <mat-form-field appearance="outline" style="width: 100%">
                          <mat-label>Cód. Contrato</mat-label>
                          <input matInput formControlName="Contrato" (keyup.enter)="onSearch()">
                          <mat-icon matSuffix>search</mat-icon>
                        </mat-form-field>
                      </div>

                    </ng-container>

                    <hr width="100%" style="margin: 5px 0px;">

                    <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarGestionConsorcio">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label *ngIf="!isConsorcioSearching">{{'Consorcio' | translate}}</mat-label>
                        <mat-label *ngIf="isConsorcioSearching">Cargando...</mat-label>
                        <mat-select formControlName="ConsorcioId">
                          <mat-option>Todos</mat-option>
                          <mat-option *ngFor="let s of consorcioList" [value]="s.Id">{{s.Nombre}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label *ngIf="!isComunidadSearching">{{'Comunidad' | translate}}</mat-label>
                        <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
                        <mat-select formControlName="ComunidadId" (selectionChange)="onDeudaFiltroUfComunidadSelect()">
                          <mat-option>Todos</mat-option>
                          <mat-option *ngFor="let s of comunidadList" [value]="s.Id">{{s.Nombre}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarGestionUf">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label *ngIf="!isUnidadesFuncionalesSearching">{{ 'UnidadFuncional' | translate}}</mat-label>
                        <mat-label *ngIf="isUnidadesFuncionalesSearching">Cargando...</mat-label>
                        <mat-select formControlName="UnidadFuncionalId">
                          <mat-option>Ninguna</mat-option>
                          <mat-option *ngFor="let s of ufList" [value]="s.Id">{{s.Codigo}}</mat-option>
                        </mat-select>
                      </mat-form-field>

                    </div>

                    <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <input type="text" placeholder="Proveedor" aria-label="Proveedor" matInput
                          [matAutocomplete]="proveedor" formControlName="Proveedor">
                        <i [ngStyle]="{'display': isProveedorAutoSearching ? 'inline-block' : 'none'}"
                          class="fa fa-spinner fa-spin" style="position: absolute; right: 0"></i>
                      </mat-form-field>
                      <mat-autocomplete #proveedor="matAutocomplete" [displayWith]="displayProveedor">
                        <mat-option *ngFor="let s of filteredProveedorList" [value]="s">
                          {{s.RazonSocial }}
                        </mat-option>
                      </mat-autocomplete>

                    </div>
                    <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label>Usuario</mat-label>
                        <input matInput formControlName="Usuario" (keyup.enter)="onSearch()">
                        <mat-icon matSuffix>search</mat-icon>
                      </mat-form-field>
                    </div>
                    <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label>Nro. Documento</mat-label>
                        <input matInput formControlName="NroDocumento" (keyup.enter)="onSearch()">
                        <mat-icon matSuffix>search</mat-icon>
                      </mat-form-field>
                    </div>

                    <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label>Email</mat-label>
                        <input matInput formControlName="MailContacto" (keyup.enter)="onSearch()">
                        <mat-icon matSuffix>search</mat-icon>
                      </mat-form-field>
                    </div>
                    <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label>Nro. Celular</mat-label>
                        <input matInput formControlName="MovilContacto" (keyup.enter)="onSearch()">
                        <mat-icon matSuffix>search</mat-icon>
                      </mat-form-field>
                    </div>
                    <div fxFlex=33 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item" style="margin-top: 20px;"  *ngIf="tenantFeatureFlags?.HabilitarControlExpensas">
                      <mat-checkbox formControlName="VerSoloAsociadosAUfs">
                        Ver solo {{'MovimientoDeuda' | translate}} de {{'UnidadFuncional' | translate}}
                      </mat-checkbox>
                    </div>

                  </div>

                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <button mat-raised-button (click)="searchGastosPendientes()" [disabled]="isMovimientoDeudaSearching" color="primary" class="zb-button">
                      {{isMovimientoDeudaSearching ? 'Buscando...' : 'Buscar Deudas'}}
                    </button>
                  </div>

                </form>

              </mat-expansion-panel>

            </div>

          </div>

          <!-- ESTADISTICAS Y FUNCIONES -->
          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" *ngIf="!isSearching">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="totalesBusqueda != null && totalesBusqueda.length > 0">
              <mat-expansion-panel [expanded]="true" hideToggle="true" style="padding-top: 10px;">
                <mat-label><b>TOTAL Pend. de Deudas:</b></mat-label>
                <br/>
                <mat-label *ngFor="let item of totalesBusqueda" style="margin: 10px 0px 0px 10px;">
                  <b>{{item.key}}:</b> <span style="margin-left: 5px;">{{item.value | number: '1.2-2'}}</span> <br/>
                </mat-label>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="totalesSeleccionados != null && totalesSeleccionados.length > 0">
              <mat-expansion-panel [expanded]="true" hideToggle="true" style="padding-top: 10px;">
                <mat-label><b>TOTAL EN PAGOS:</b></mat-label>
                <br/>
                <mat-label *ngFor="let item of totalesSeleccionados" style="margin: 10px 0px 0px 10px;">
                  <b>{{item.key}}:</b> <span style="margin-left: 5px;">{{item.value | number: '1.2-2'}}</span> <br/>
                </mat-label>
              </mat-expansion-panel>
            </div>

          </div>

          <!--GRILLA DE DEUDAS-->
          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">

              <mat-expansion-panel [expanded]="true" hideToggle="false">

                <div fxLayout="row stretch" class="zb-readonly" style="margin-top: 15px;">

                  <div fxFlex=100 fxFlex.xs=100 class="flex-item">

                    <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="isMovimientoDeudaSearching">
                      <mat-label class="text-style"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
                    </div>
                    <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isMovimientoDeudaSearching">

                      <ejs-grid #deudasPendientesGrid [dataSource]='deudasPendientesList' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions'
                        [selectionSettings]='selectionOptions' [pageSettings]='pageSettings' [allowResizing]='true' [contextMenuItems]='contextMenuItems'
                        (contextMenuClick)='contextMenuClick($event)' (contextMenuOpen)='contextMenuOpen($event)'>
                        <e-columns>
                          <e-column width=45 tabindex="-1">
                            <ng-template #template let-data>
                              <a style="cursor: pointer;" (click)="doMovimientoDelete(data.Id)" title="Eliminar del listado" *ngIf="!pagosSaved">
                                <i class="fa fa-times fa-1x"></i>
                              </a>
                              <a style="cursor: pointer;" (click)="doGeneracionReciboPago(data.PagoId)" title="Descargar recibo" *ngIf="data.PagoId != null && data.PagoId > 0">
                                <i class="fa fa-file fa-1x"></i>
                              </a>
                            </ng-template>
                          </e-column>
                          <e-column field='FechaMovimiento' headerText='Fecha Movimiento' width=80 type='date' format="dd/MM/yyyy" tabindex="-1">
                            <ng-template #template let-data>
                              {{data.FechaMovimiento | date:'dd/MM/yyyy'}}
                            </ng-template>
                          </e-column>
                          <e-column field='FechaVencimiento' headerText='Vencimiento' width=80 type='date' format="dd/MM/yyyy" tabindex="-1">
                            <ng-template #template let-data>
                              {{data.FechaVencimiento | date:'dd/MM/yyyy'}}
                            </ng-template>
                          </e-column>
                          <e-column field='CuentaImputada' headerText='Referencia' width=90 tabindex="-1"></e-column>
                          <e-column field='Detalle' headerText='Detalle' width=120 tabindex="-1"></e-column>
                          <e-column field='TipoMovimientoNombre' headerText='Tipo' width=70 tabindex="-1"></e-column>
                          <e-column field='Monto' headerText='Total' width=80 format="N2" textAlign='Right' tabindex="-1">
                            <ng-template #template let-data>
                              {{data.Moneda}} {{data.Monto | number:'1.2-2'}}
                            </ng-template>
                          </e-column>
                          <e-column field='Saldo' headerText='Pendiente' width=90 format="N2" textAlign='Right' tabindex="-1">
                            <ng-template #template let-data>
                              {{data.Moneda}} {{data.Saldo | number:'1.2-2'}}
                            </ng-template>
                          </e-column>
                          <e-column field='SaldoConvertido' headerText='Saldo Convertido' width=90 format="N2" textAlign='Right' tabindex="-1">
                            <ng-template #template let-data>
                              {{data.MonedaPago != null ? data.MonedaPago.Codigo : data.Moneda}} {{data.SaldoConvertido | number:'1.2-2'}}
                            </ng-template>
                          </e-column>
                          <e-column field='MonedaPagoId' headerText='Moneda Pago' width=90>
                            <ng-template #template let-data>
                              <mat-label class="text-style" *ngIf="isMonedaSearching">Cargando...</mat-label>
                              <mat-select class="text-style" [(ngModel)]="data.MonedaPagoId" name="MonedaPagoId" (selectionChange)="onDeudaGridFieldChange(data.Id, $event)" *ngIf="!isMonedaSearching"
                                style="padding: 4px 2px; width: 90%; border: 1px black solid; text-align: left;">
                                <mat-option class="text-style" *ngFor="let s of monedaList" [value]="s.Id">{{s.Codigo}} - {{s.Nombre}}</mat-option>
                              </mat-select>
                            </ng-template>
                          </e-column>
                          <e-column field='MontoBase' headerText='Monto Pagado' width=90>
                            <ng-template #template let-data>
                              <input matInput type="number" [(ngModel)]="data.MontoPago" name="MontoPago" maxlength="30"
                                (change)="onDeudaGridFieldChange(data.Id, $event)" style="padding:5px; width: 80%; border: 1px black solid; text-align: left;">
                            </ng-template>
                          </e-column>
                        </e-columns>
                      </ejs-grid>

                    </div>

                  </div>

                </div>

              </mat-expansion-panel>

            </div>

          </div>

          <!--OPERACIONES SOBRE LAS DEUDAS-->
          <div fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="end" class="zb-readonly" *ngIf="!isSearching">

            <ng-container *ngIf="deudasPendientesList != null && deudasPendientesList.length > 0 && !pagosSaved">
                <button mat-raised-button (click)="autocompletarPagos()" class="zb-button" [disabled]="isProcessing()" style="margin-bottom: 5px;">
                  Autocompletar {{'MovimientoPago' | translate}}s
                </button>
                <button mat-raised-button color="primary" (click)="exportarDeudas()" class="zb-button" [disabled]="isProcessing()" style="margin-left: 5px; margin-bottom: 5px;">
                  {{isDeudasExporting ? 'Exportando...' : 'Exportar'}}
                </button>
                <button mat-raised-button color="primary" (click)="fileDeudasPagosInput.click()" class="zb-button" [disabled]="isProcessing()" *ngIf="exportoDeudas" style="margin-left: 5px; margin-bottom: 5px;">
                  {{isImportingDeudasPagos ? 'Importando...' : 'Importar'}}
                </button>
                <input hidden type="file" (change)="convertFileDeudasPagosToBase64($event)" #fileDeudasPagosInput color="primary">
            </ng-container>

          </div>

        </mat-tab>

        <!--IMPORTAR PAGOS DESDE ARCHIVO-->
        <mat-tab label="Importar desde Archivo">

          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" *ngIf="!pagosSaved" style="margin-top: 10px;">

            <div fxFlex=100 fxFlex.xs=100 class="flex-item" *ngIf="!pagosSaved">

              <mat-expansion-panel [expanded]="true" hideToggle="true" style="padding-top: 15px; text-align: center;">

                <button mat-raised-button (click)="downloadTemplatePagos()" [disabled]="isProcessing()" style="margin-bottom: 5px;">
                  {{isTemplateDownloading ? 'Descargando...' : 'Descargar Template Pagos'}}
                </button>

                <button mat-raised-button color="primary" (click)="filePagosInput.click()" [disabled]="isProcessing()" style="margin-left: 5px; margin-bottom: 5px;">
                  {{isPagosUploading ? 'Adjuntando...' : 'Adjuntar Pagos'}}
                </button>
                <input hidden type="file" (change)="convertFilePagosToBase64($event)" #filePagosInput color="primary">

                <ng-container *ngIf="pagosFileName != null && pagosFileName.length > 0">
                  <br/><br/>
                  <mat-label>{{pagosFileName}}</mat-label>
                </ng-container>

              </mat-expansion-panel>

            </div>

          </div>

        </mat-tab>

      </mat-tab-group>

    </mat-expansion-panel>

    <!--DATOS DE MOVIMIENTO-->
    <form [formGroup]="formGroup" *ngIf="!pagosSaved">

      <!-- DATOS DEL MOVIMIENTO -->
      <mat-expansion-panel [expanded]="true" style="margin-bottom: 1%;">

        <mat-expansion-panel-header>
          <mat-panel-title class="card-subtitulo">
            <mat-icon style="margin-top: -3px;">settings</mat-icon> Datos Generales de los Movimientos
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

          <!-- Fecha de Movimiento + Tipo de Movimiento -->
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%" >
              <mat-label>Fecha de Movimiento*</mat-label>
              <input matInput [matDatepicker]="fechaMovimientoPicker" formControlName="FechaMovimiento"  (click)="fechaMovimientoPicker.open()">
              <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaMovimientoPicker">
              </mat-datepicker-toggle>
              <mat-datepicker #fechaMovimientoPicker></mat-datepicker>
              <mat-error *ngIf="!formGroup.controls['FechaMovimiento'].valid && formGroup.controls['FechaMovimiento'].touched">
                {{ getErrorFechaMovimiento() }}
              </mat-error>
            </mat-form-field>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label *ngIf="!isTipoMovimientoSearching">Tipo de Movimiento*</mat-label>
              <mat-label *ngIf="isTipoMovimientoSearching">Cargando...</mat-label>
              <mat-select formControlName="TipoMovimientoId">
                <mat-option *ngFor="let s of tipoMovimientoList" [value]="s.Id">{{s.Nombre}}</mat-option>
              </mat-select>
              <mat-error *ngIf="!formGroup.controls['TipoMovimientoId'].valid && formGroup.controls['TipoMovimientoId'].touched">
                {{ getErrorTipoMovimientoId() }}
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Detalle -->
          <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="width: 100%">
            <mat-form-field appearance="outline" style="width: 100%" >
              <mat-label>Detalle*</mat-label>
              <input matInput formControlName="Detalle" maxlength="100" (keyup.enter)="onGuardar()">
              <mat-error *ngIf="!formGroup.controls['Detalle'].valid && formGroup.controls['Detalle'].touched">
                {{ getErrorDetalle() }}
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Observacion -->
          <div fxFlex=100 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label class="text-style">Observación</mat-label>
              <textarea matInput formControlName="Observacion" maxlength="300"></textarea>
              <mat-error *ngIf="!formGroup.controls['Observacion'].valid && formGroup.controls['Observacion'].touched">
                {{ getErrorObservacion() }}
              </mat-error>
            </mat-form-field>
          </div>

        </div>

        <hr style="margin: 10px 0px; width: 100%;">

        <!-- Medio Pago + Seleccion Cuenta Credito-->
        <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label *ngIf="!isMedioPagoSearching">Medio de Pago*</mat-label>
              <mat-label *ngIf="isMedioPagoSearching">Cargando...</mat-label>
              <mat-select formControlName="MedioPagoId" (selectionChange)="onMedioPagoSelect()">
                <mat-option *ngFor="let s of medioPagoList" [value]="s.Id">{{s.Nombre}}</mat-option>
              </mat-select>
              <mat-error *ngIf="!formGroup.controls['MedioPagoId'].valid && formGroup.controls['MedioPagoId'].touched">
                {{ getErrorMedioPagoId() }}
              </mat-error>
            </mat-form-field>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="debeSeleccionarCuentaImputada" style="margin-top: 10px;">
            <!-- <mat-expansion-panel [expanded]="true" hideToggle="true"> -->
              <div fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="center center">
                <button mat-raised-button (click)="openDialogCuentaCreditoSearch()" [disabled]="isProcessing()" color="primary" class="zb-button">
                  <mat-icon style="margin-right: 3px;">search</mat-icon>Buscar Cuenta con Crédito
                </button>
                <button mat-raised-button (click)="cleanCuentaImputada()" *ngIf="cuentaImputada != null" [disabled]="isProcessing()"
                  style="margin-left: 3px;" color="warn" class="zb-button" title="Limpiar cuenta seleccionada">
                  <mat-icon style="margin-right: 3px;">delete_forever</mat-icon>
                </button>
              </div>
            <!-- </mat-expansion-panel> -->
          </div>

        </div>

        <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" *ngIf="debeSeleccionarCuentaImputada">

          <ng-container *ngIf="cuentaImputada != null">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="cuentaImputada.Codigo != null && cuentaImputada.Codigo.length > 0">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-label"><b>Código </b>: {{cuentaImputada.Codigo}}</mat-label>
                </div>
              </mat-expansion-panel>

              <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!(cuentaImputada.Codigo != null && cuentaImputada.Codigo.length > 0)">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-label">
                    <b>Código </b>:
                    <span *ngIf="cuentaImputada.PersonaNombre != null && cuentaImputada.PersonaNombre?.length > 0">{{cuentaImputada.PersonaNombre}}</span>
                    <span *ngIf="cuentaImputada.Proveedor != null && cuentaImputada.Proveedor?.length > 0">{{cuentaImputada.Proveedor}}</span>
                    <span *ngIf="cuentaImputada.Comunidad != null && cuentaImputada.Comunidad?.length > 0">{{cuentaImputada.Comunidad}}</span>
                    <span *ngIf="cuentaImputada.Consorcio != null && cuentaImputada.Consorcio?.length > 0">{{cuentaImputada.Consorcio}}</span>
                    <span *ngIf="cuentaImputada.UnidadFuncional != null && cuentaImputada.UnidadFuncional?.length > 0">{{cuentaImputada.UnidadFuncional}}</span>
                  </mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-label" *ngIf="iscuentaImputadaSearching"><i class="fa fa-spinner fa-spin"></i></mat-label>
                  <mat-label class="text-label" *ngIf="!iscuentaImputadaSearching"><b>Saldo Disponible</b>: {{cuentaImputadaSaldo?.Moneda}} {{cuentaImputadaSaldo?.Saldo | number:'1.2-2'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <ng-container *ngIf="cuentaImputada.Id > 0 && !cuentaImputada.EsCuentaCorrienteInterna">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-label"><b>CBU/CVU</b>: {{cuentaImputada.ClaveBancaria}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-label"><b>Alias</b>: {{cuentaImputada.Alias}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-label"><b>Banco</b>: {{cuentaImputada.BancoNombre}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-label"><b>Número de Cuenta</b>: {{cuentaImputada.NumeroCuenta}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-label"><b>Titular</b>: {{cuentaImputada.Titular}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

            </ng-container>

          </ng-container>

        </div>

      </mat-expansion-panel>

    </form>

  </mat-card-content>

  <mat-card-actions>
    <div fxLayout="row stretch" fxLayout.xs="column">
      <button mat-raised-button (click)="onGuardar()" *ngIf="!pagosSaved" [disabled]="isProcessing()" color="primary" class="zb-button">
        {{isSaving ? 'Guardando...' : 'Guardar'}}
      </button>
      <button mat-raised-button (click)="onGeneracionRecibo()" *ngIf="pagosSaved">Descargar Recibos</button>
      <button mat-raised-button (click)="onCancel()" color="warn">Cerrar</button>
      <button mat-raised-button (click)="onRestart()" *ngIf="pagosSaved" color="primary">Cargar Nuevos Pagos</button>
    </div>
  </mat-card-actions>

</mat-card>
